const isMobileDevice = () => {
  const ua = navigator.userAgent;

  if (/Mac OS/i.test(ua)) return false;

  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
    ua
  );
};

module.exports = {
  isMobileDevice
};
